import React from 'react';
import { Hero } from '../components/home/Hero';
import { ServiceCategories } from '../components/home/ServiceCategories';
import { PopularServices } from '../components/home/PopularServices';
import { StatsSection } from '../components/home/StatsSection';
import { NewsUpdates } from '../components/home/NewsUpdates';
import { HowItWorks } from '../components/home/HowItWorks';
import { Testimonials } from '../components/home/Testimonials';
import { CtaSection } from '../components/home/CtaSection';
export const Home = () => {
  return <div data-id="element-457">
      <Hero data-id="element-458" />
      <ServiceCategories data-id="element-459" />
      <PopularServices data-id="element-460" />
      <HowItWorks data-id="element-461" />
      <StatsSection data-id="element-462" />
      <NewsUpdates data-id="element-463" />
      <Testimonials data-id="element-464" />
      <CtaSection data-id="element-465" />
    </div>;
};